export default __webpack_public_path__ + "23a29a583be38e027cfffa8d5074af6f.png";